import { makeObservable, observable } from 'mobx'

import type { ScenarioService } from '@/service/scenario.service'

import { DTO } from '../DTO'
import type { User } from '../Teacher'

export class Scenario extends DTO {
  id: ValueOf<(typeof ScenarioService)['scenarioIds']>
  프로필: {
    descHTML: (name: User['name']) => string
  }
  시나리오카드: {
    title: string
    descHTML: string
  }
  완료팝업: {
    title: string
    descHTML: string
    ctaButton: {
      text: string
      width: number
    }
  }
  기능설명팝업: {
    preTitle: string
    title: string
    descHTML?: string
    type: '비디오' | '이미지'
    resourceUrl: string
    ctaButton: {
      text: string
      // pathname: ValueOf<typeof RouteName>
      width: number
      onClick: (id: Scenario['id']) => void
    }
  }
  order: number

  constructor(data: Omit<Scenario, '기능설명Click' | 'update' | 'updateExceptNullable' | 'toJS'>) {
    super()
    makeObservable(this, {
      id: observable,
      프로필: observable,
      시나리오카드: observable,
      완료팝업: observable,
      기능설명팝업: observable,
    })
    this.id = data.id
    this.프로필 = data.프로필
    this.시나리오카드 = data.시나리오카드
    this.완료팝업 = data.완료팝업
    this.기능설명팝업 = data.기능설명팝업
    this.order = data.order
  }
}
